const pu = {
  "भाजपा सदस्यता अभियान - 2024": "ਭਾਜਪਾ ਮੁਹਿੰਮ - 2024",
  "Select Language": "ਭਾਸ਼ਾ ਚੁਣੋ",
  Next: "ਅਗਲਾ",
  "Enter your mobile number": "ਆਪਣਾ ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ",
  "I accept the Terms and Conditions, and by continuing, I consent to voluntarily become a member of the BJP":
    "ਮੈਂ ਨਿਯਮਾਂ ਅਤੇ ਸ਼ਰਤਾਂ ਨੂੰ ਸਵੀਕਾਰ ਕਰਦਾ ਹਾਂ, ਅਤੇ ਜਾਰੀ ਰੱਖ ਕੇ, ਮੈਂ ਸਵੈ-ਇੱਛਾ ਨਾਲ ਭਾਜਪਾ ਦਾ ਮੈਂਬਰ ਬਣਨ ਲਈ ਸਹਿਮਤੀ ਦਿੰਦਾ ਹਾਂ",
  "Get OTP": "OTP ਪ੍ਰਾਪਤ ਕਰੋ",
  "Terms and Conditions": "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
  "You must tick the box to continue, as it is mandatory.":
    "ਜਾਰੀ ਰੱਖਣ ਲਈ ਤੁਹਾਨੂੰ ਬਾਕਸ 'ਤੇ ਨਿਸ਼ਾਨ ਲਗਾਉਣਾ ਚਾਹੀਦਾ ਹੈ, ਕਿਉਂਕਿ ਇਹ ਲਾਜ਼ਮੀ ਹੈ।",
  "Okay, Got it": "ਠੀਕ ਹੈ, ਸਮਝ ਲਿਆ",
  "Get OTP": "OTP ਪ੍ਰਾਪਤ ਕਰੋ",
  "Enter OTP": "OTP ਦਾਖਲ ਕਰੋ",
  "Resend OTP": "OTP ਦੁਬਾਰਾ ਭੇਜੋ",
  Continue: "ਜਾਰੀ ਰੱਖੋ",
  "Fill details": "ਵੇਰਵੇ ਭਰੋ",
  "Upload Photo": "ਫੋਟੋ ਅੱਪਲੋਡ ਕਰੋ",
  "Profile Photo": "ਪ੍ਰੋਫਾਈਲ ਫੋਟੋ",
  "Mobile number": "ਮੋਬਾਇਲ ਨੰਬਰ",
  "Mrs.": "ਸ਼੍ਰੀਮਤੀ",
  "Mr.": "ਮਿਸਟਰ",
  Ms: "ਸ਼੍ਰੀਮਤੀ",
  "Full Name*": "ਪੂਰਾ ਨਾਮ *",
  "D.O.B": "D.O.B",
  Age: "ਉਮਰ",
  Gender: "ਲਿੰਗ",
  Female: "ਔਰਤ",
  Male: "ਮਰਦ",
  Other: "ਹੋਰ",
  "Email Id": "ਈਮੇਲ ਆਈ.ਡੀ",
  "Add address": "ਪਤਾ ਸ਼ਾਮਲ ਕਰੋ",
  "House/ Flat/ Floor No.": "ਮਕਾਨ/ਫਲੈਟ/ਮੰਜ਼ਿਲ ਨੰ.",
  "Current address PIN code": "ਮੌਜੂਦਾ ਪਤਾ ਪਿੰਨ ਕੋਡ",
  "District*": "ਜ਼ਿਲ੍ਹਾ*",
  State: "ਰਾਜ",
  "Assembly constituency (AC)": "ਵਿਧਾਨ ਸਭਾ ਹਲਕਾ (AC)",
  "Tell us about your location": "ਸਾਨੂੰ ਆਪਣੇ ਪਤੇ ਬਾਰੇ ਦੱਸੋ",
  "It will assist us in locating other members in your area.":
    "ਇਹ ਤੁਹਾਡੇ ਖੇਤਰ ਵਿੱਚ ਹੋਰ ਮੈਂਬਰਾਂ ਦਾ ਪਤਾ ਲਗਾਉਣ ਵਿੱਚ ਸਾਡੀ ਮਦਦ ਕਰੇਗਾ।",
  "Your address as fetched": "ਪ੍ਰਾਪਤ ਕੀਤੇ ਅਨੁਸਾਰ ਤੁਹਾਡਾ ਪਤਾ",
  "Referral code": "ਰੈਫਰਲ ਕੋਡ",
  "I certify that above provided information is correct and there is no mistake. I know that all further communication will be done on above provided details":
    "ਮੈਂ ਪ੍ਰਮਾਣਿਤ ਕਰਦਾ/ਕਰਦੀ ਹਾਂ ਕਿ ਉੱਪਰ ਦਿੱਤੀ ਗਈ ਜਾਣਕਾਰੀ ਸਹੀ ਹੈ ਅਤੇ ਕੋਈ ਗਲਤੀ ਨਹੀਂ ਹੈ। ਮੈਨੂੰ ਪਤਾ ਹੈ ਕਿ ਉੱਪਰ ਦਿੱਤੇ ਵੇਰਵਿਆਂ 'ਤੇ ਅੱਗੇ ਦਾ ਸਾਰਾ ਸੰਚਾਰ ਕੀਤਾ ਜਾਵੇਗਾ",
  Save: "ਸੇਵ ਕਰੋ",
  Select: "ਚੁਣੋ",
  Camera: "ਕੈਮਰਾ",
  or: "ਜਾਂ",
  Gallery: "ਗੈਲਰੀ",
  "Support format : Jpeg, Png, Pdf": "ਸਪੋਰਟ ਫਾਰਮੈਟ: Jpeg, Png, Pdf",
  Cancel: "ਰੱਦ ਕਰੋ",
  "Select location": "ਟਿਕਾਣਾ ਚੁਣੋ",
  "Provide location": "ਸਥਾਨ ਪ੍ਰਦਾਨ ਕਰੋ",
  "Search results": "ਖੋਜ ਨਤੀਜੇ",
  "Search for a building, street name or..": "ਕਿਸੇ ਇਮਾਰਤ, ਗਲੀ ਦਾ ਨਾਮ ਜਾਂ...",
  "Your address as fetched": "ਪ੍ਰਾਪਤ ਕੀਤੇ ਅਨੁਸਾਰ ਤੁਹਾਡਾ ਪਤਾ",
  "Locate me": "ਮੈਨੂੰ ਲੱਭੋ",
  "Confirm location": "ਟਿਕਾਣੇ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
  "Congratulations !": "ਵਧਾਈਆਂ!",
  "Your primary Id is -": "ਤੁਹਾਡੀ ਪ੍ਰਾਇਮਰੀ ਆਈਡੀ ਹੈ -",
  "Login in to Bjp.org/membership to enhance your data, access your ID card, and refer others to join as primary members.":
    "Bjp.org/membership ਵਿੱਚ ਲੌਗਇਨ ਕਰੋ ਆਪਣੇ ਡੇਟਾ ਨੂੰ ਵਧਾਉਣ ਲਈ, ਆਪਣੇ ਆਈਡੀ ਕਾਰਡ ਤੱਕ ਪਹੁੰਚ ਕਰੋ, ਅਤੇ ਹੋਰਾਂ ਨੂੰ ਪ੍ਰਾਇਮਰੀ ਮੈਂਬਰਾਂ ਵਜੋਂ ਸ਼ਾਮਲ ਹੋਣ ਲਈ ਵੇਖੋ।",
  "ID CARD": "ਆਈ ਡੀ ਕਾਰਡ",
  "You can download your generated ID Card":
    "ਤੁਸੀਂ ਆਪਣਾ ਤਿਆਰ ਕੀਤਾ ਆਈ ਡੀ ਕਾਰਡ ਡਾਊਨਲੋਡ ਕਰ ਸਕਦੇ ਹੋ",
  Download: "ਡਾਊਨਲੋਡ ਕਰੋ",
  "Go to dashboard": "ਡੈਸ਼ਬੋਰਡ 'ਤੇ ਜਾਓ",
  "View your profile": "ਆਪਣਾ ਪ੍ਰੋਫਾਈਲ ਦੇਖੋ",
  "Refer and add member": "ਵੇਖੋ ਅਤੇ ਮੈਂਬਰ ਸ਼ਾਮਲ ਕਰੋ",
  Share: "ਸ਼ੇਅਰ ਕਰੋ",
  "To update your additional details and refer more member, please click here.":
    "ਆਪਣੇ ਵਾਧੂ ਵੇਰਵਿਆਂ ਨੂੰ ਅੱਪਡੇਟ ਕਰਨ ਅਤੇ ਹੋਰ ਮੈਂਬਰ ਦਾ ਹਵਾਲਾ ਦੇਣ ਲਈ, ਕਿਰਪਾ ਕਰਕੇ ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ।",
  "Bharatiya Janata Party": "ਭਾਰਤੀ ਜਨਤਾ ਪਾਰਟੀ",
  "6A, DEENDAYAL UPADHYAYA MARG, NEW DELHI - 110002":
    "6ਏ, ਦੀਨਦਿਆਲ ਉਪਾਧਿਆਏ ਮਾਰਗ, ਨਵੀਂ ਦਿੱਲੀ - 110002",
  Name: "ਨਾਮ",
  "Membership Number": "ਮੈਂਬਰਸ਼ਿਪ ਨੰਬਰ",
  "QR Code": "QR ਕੋਡ",
  "Please select a year between 1930 and 2006.":
    "ਕਿਰਪਾ ਕਰਕੇ 1930 ਅਤੇ 2006 ਵਿਚਕਾਰ ਕੋਈ ਸਾਲ ਚੁਣੋ।",
  "Please enter a valid email address.": "ਇੱਕ ਜਾਇਜ ਈਮੇਲ ਪਤਾ ਦਰਜ ਕਰੋ.",
  "Please enter 6-digit PIN code.": "ਕਿਰਪਾ ਕਰਕੇ 6-ਅੰਕ ਦਾ ਪਿੰਨ ਕੋਡ ਦਾਖਲ ਕਰੋ।",
  "10-digit mobile number.": "10-ਅੰਕਾਂ ਵਾਲਾ ਮੋਬਾਈਲ ਨੰਬਰ।",
  "Please enter a 10-digit mobile number.":
    "ਕਿਰਪਾ ਕਰਕੇ 10-ਅੰਕ ਦਾ ਮੋਬਾਈਲ ਨੰਬਰ ਦਾਖਲ ਕਰੋ।",
  "Please enter your name.": "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਨਾਮ ਦਰਜ ਕਰੋ।",
  "I pledge and willing to receive regular updates from BJP":
    "ਮੈਂ ਵਾਅਦਾ ਕਰਦਾ ਹਾਂ ਅਤੇ ਭਾਜਪਾ ਤੋਂ ਨਿਯਮਤ ਅਪਡੇਟਸ ਪ੍ਰਾਪਤ ਕਰਨ ਲਈ ਤਿਆਰ ਹਾਂ",
  "Get Verification Code": "ਸਤ੍ਹਾਪਨ ਕੋਡ ਪ੍ਰਾਪਤ ਕਰੋ",
  "Enter Verification Code": "ਸਤ੍ਹਾਪਨ ਕੋਡ ਦਰਜ ਕਰੋ",
  "Resend Verification Code": "ਸਤ੍ਹਾਪਨ ਕੋਡ ਦੁਬਾਰਾ ਭੇਜੋ",
  "Provide Details": "ਵੇਰਵਾ ਦਿਓ",
  Upload: "ਅਪਲੋਡ ਕਰੋ",
  Ok: "ਠੀਕ ਹੈ",
  Calendar: "ਕੈਲੰਡਰ",
  "Full Address": "ਪੂਰਾ ਪਤਾ",
  "Privacy policy": "ਗੋਪਨੀਯਤਾ ਨੀਤੀ",
  Disclaimer: "ਅਸਵੀਕਾਰੀ",
  "Contact us": "ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
  Save: "ਸੇਵ ਕਰੋ",
  "Your primary member ID": "ਤੁਹਾਡਾ ਪ੍ਰਾਇਮਰੀ ਮੈਂਬਰ ਆਈਡੀ",
  "Membership Card": "ਮੈਂਬਰਸ਼ਿਪ ਕਾਰਡ",
  "Your Unique Referral code": "ਤੁਹਾਡਾ ਵਿਲੱਖਣ ਸੰਦਰਭ ਕੋਡ",
  "Invite and add member": "ਮੈਂਬਰ ਨੂੰ ਸੱਦਾ ਦਿਓ ਅਤੇ ਜੋੜੋ",
  Share: "ਸਾਂਝਾ ਕਰੋ",
  "Click below to add more details, donate and add other members to BJP":
    "ਵਧੇਰੇ ਵੇਰਵੇ ਜੋੜਣ, ਦਾਨ ਕਰਨ ਅਤੇ ਹੋਰ ਮੈਂਬਰਾਂ ਨੂੰ BJP ਨਾਲ ਜੋੜਨ ਲਈ ਹੇਠਾਂ ਕਲਿੱਕ ਕਰੋ",
  "Update your details": "ਆਪਣੇ ਵੇਰਵੇ ਅਪਡੇਟ ਕਰੋ",
  "Add Referral Details": "ਰਿਫਰਲ ਵੇਰਵੇ ਜੋੜੋ",
  "Referred by (name)": "ਰਿਫਰ ਕਰਨ ਵਾਲਾ (ਨਾਮ)",
  "Referred by (mobile number)": "ਰਿਫਰ ਕਰਨ ਵਾਲਾ (ਮੋਬਾਈਲ ਨੰਬਰ)",
  Capture: "ਕੈਪਚਰ ਕਰੋ",
  "Close Camera": "ਕੈਮਰਾ ਬੰਦ ਕਰੋ",
  Uploading: "ਅੱਪਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ",
  "Your Unique Referral Link": "ਤੁਹਾਡਾ ਵਿਲੱਖਣ ਰੈਫਰਲ ਲਿੰਕ",
  "You've reached the maximum OTP attempts for today. Please try again tomorrow":
    "ਤੁਸੀਂ ਅੱਜ ਲਈ ਅਧਿਕਤਮ OTP ਕੋਸ਼ਿਸ਼ਾਂ 'ਤੇ ਪਹੁੰਚ ਗਏ ਹੋ। ਕਿਰਪਾ ਕਰਕੇ ਕੱਲ੍ਹ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
  Miss: "ਸ਼੍ਰੀਮਤੀ",
  "OTP limit reached for today. Please try again tomorrow":
    "ਅੱਜ ਲਈ OTP ਸੀਮਾ ਪੂਰੀ ਹੋ ਗਈ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਕੱਲ੍ਹ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
  ": is not a Primary Member, Only Primary Members can refer":
    ": ਪ੍ਰਾਇਮਰੀ ਮੈਂਬਰ ਨਹੀਂ ਹੈ, ਸਿਰਫ਼ ਪ੍ਰਾਇਮਰੀ ਮੈਂਬਰ ਹੀ ਹਵਾਲਾ ਦੇ ਸਕਦੇ ਹਨ",
  "Please enter valid fullname": "",
  "Full Name": "ਪੂਰਾ ਨਾਂਮ",
};

export default pu;
